import css from '../ListingPageDescription.module.css';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TiktokIcon,
  WebSiteIcon,
  YoutubeIcon,
} from './SocialMediaIcons';

export const SocialMediaTypes = {
  WEBSITE: 'Website',
  LINKEDIN: 'LinkedIn',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'Youtube',
  TIKTOK: 'TikTok',
};

export const SocialMediaIcons = {
  WEBSITE: WebSiteIcon,
  LINKEDIN: LinkedinIcon,
  FACEBOOK: FacebookIcon,
  INSTAGRAM: InstagramIcon,
  YOUTUBE: YoutubeIcon,
  TIKTOK: TiktokIcon,
};

const addHttpIfMissing = url => {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return 'http://' + url;
  }
  return url;
};

export const SocialMediaField = ({ url, type }) => {
  const Icon = SocialMediaIcons?.[type];
  return (
    <div className={css.fieldWithIconWrapper}>
      <Icon />
      <a
        className={css.fieldWithIconText}
        type={'social'}
        href={addHttpIfMissing(url)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {SocialMediaTypes?.[type]}
      </a>
    </div>
  );
};
